import { render } from "./Catalogues.vue?vue&type=template&id=a3570334"
import script from "./Catalogues.vue?vue&type=script&lang=js"
export * from "./Catalogues.vue?vue&type=script&lang=js"

import "./Catalogues.vue?vue&type=style&index=0&id=a3570334&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__